/**
 * Plany Free i Premium (decyzje właściciela 2026-10-19, `second-brain/01_BIZNES.md`, „Podział funkcji: bez konta, Free,
 * Premium”; zadania w repo VV `zadania/2026-10_plany-free-premium.md`).
 *
 * ═══ ŹRÓDŁO PRAWDY TO BACKEND ═══
 * Który plan ma firma i jakie funkcje są dziś dostępne, mówi `GET /api/v1/account/me` (`funkcje`, `company.plan`,
 * `company.proba` …). Ten plik trzyma tylko to, czego interfejs potrzebuje do opisu: nazwy funkcji, ceny i limity.
 * W kodzie pytamy o funkcję (`useMozna('projekt3d')`), nigdy o nazwę planu.
 *
 * Kwoty netto. Płatności jeszcze nie ma (FP-12): Premium włączamy ręcznie po kontakcie.
 */

/** Funkcje Premium. Klucze MUSZĄ zgadzać się z `UPRAWNIENIA_PLANU` w backendzie (kontrakt w pliku zadań). */
export const FUNKCJE_PREMIUM = {
  projekt3d: { nazwa: 'Projekt 3D', opis: 'model dachu z cieniem i produkcją dla adresu klienta' },
  historia_cen_w_zestawach: { nazwa: 'Historia cen w zestawach', opis: 'jak zmieniała się cena sprzętu w doborze' },
  zgloszenie_osd: { nazwa: 'Zgłoszenie do operatora sieci', opis: 'wniosek i załączniki dla operatora' },
  zawiadomienie_psp: { nazwa: 'Zawiadomienie straży pożarnej', opis: 'zawiadomienie i plan dla instalacji powyżej 6,5 kW' },
  teczka_pme2: { nazwa: 'Teczka dotacji PME2', opis: 'dokumenty do wniosku o dotację' },
  zamowienia: { nazwa: 'Zamówienia i stan sprzętu', opis: 'co zamówione, co dojechało, co już u klienta' },
  pogoda: { nazwa: 'Prognoza pogody na montaże', opis: 'pogoda na dni zaplanowanych montaży' },
  uprawnienia_zespolu: { nazwa: 'Uprawnienia w zespole', opis: 'kto widzi wszystkich klientów i zmienia ustawienia' },
  statystyki_zespolu: { nazwa: 'Statystyki zespołu', opis: 'wyniki każdej osoby w firmie' },
  marka_dokumentu: { nazwa: 'Logo i kolor firmy w dokumentach', opis: 'oferta i projekt PDF z Twoją marką' },
}

/** Kolejność na liście „co daje Premium” (okno i cennik). */
export const KOLEJNOSC_FUNKCJI = [
  'projekt3d', 'zgloszenie_osd', 'zawiadomienie_psp', 'teczka_pme2', 'marka_dokumentu', 'zamowienia', 'pogoda',
  'uprawnienia_zespolu', 'statystyki_zespolu',
]

export const nazwaFunkcji = (klucz) => FUNKCJE_PREMIUM[klucz]?.nazwa || 'Ta funkcja'

/**
 * Znaczniki formalności w karcie klienta, których zmiana wymaga funkcji Premium (decyzja D6, 2026-10-19). Backend
 * odrzuca taką zmianę we Free (402), więc front od razu otwiera okno Premium. „Umowa podpisana” jest we Free.
 */
export const FUNKCJE_ZNACZNIKOW = {
  osdWyslane: 'zgloszenie_osd',
  pspWyslane: 'zawiadomienie_psp',
  pme2Zlozony: 'teczka_pme2',
}

export const CENNIK = {
  premiumMiesiecznie: 189,
  // Rocznie 10 × cena miesięczna.
  premiumRocznie: 1890,
  promocja: {
    cena: 99,
    miesiecy: 6,
    // Dla Premium założonego do tego dnia włącznie, tylko plan miesięczny.
    zalozoneDo: '2026-12-31',
  },
  pakietKont: { kont: 10, miesiecznie: 29, rocznie: 290 },
}

export const LIMIT_KONT = { free: 2, premium: 5 }

export const DNI_PROBY = 31

/**
 * Dopóki nie ma płatności online (decyzja właściciela 2026-10-19): zamiast „Napisz do nas o Premium” przycisk
 * „Odbierz darmowy dostęp” (miesiąc Premium za darmo, można odebrać ponownie po jego końcu), a w czasie Premium
 * komunikat „Masz Premium do …” zamiast licznika próby. Backend: `PLANY_DARMOWY_DOSTEP` w `settings.py`.
 * Przy wdrożeniu płatności `false` w obu miejscach.
 */
export const DARMOWY_DOSTEP = true

/**
 * Konto bez firmy (prywatne albo firmowe przed NIP-em) też ma miesiąc Premium od rejestracji (backend
 * `PLANY_PROBA_BEZ_FIRMY`, plan w `/me` jako `plan_konta`). Tymczasowe: właściciel chce do tego wrócić i może
 * przywrócić próbę tylko z NIP-em. Od tego zależą tylko teksty (cennik, okno Premium).
 */
export const PROBA_BEZ_FIRMY = true

/** Dokąd pisać o Premium, dopóki nie ma płatności online. */
export const KONTAKT_PREMIUM = 'kontakt@voltvalue.pl'

/**
 * Pomiar zdarzeń `okno_premium` i `limit_bez_konta` (`lib/pomiar`). Backend odrzuca zdarzenia, których nie zna;
 * BE-05 (wpisy w `pomiar/models.py`, migracja `pomiar 0007`) jest na produkcji od 2026-10-19, więc pomiar włączony.
 */
export const POMIAR_PLANOW_WLACZONY = true

/** Czy promocja jeszcze trwa (dzień końca włącznie, czas lokalny). */
export const promocjaTrwa = (dzis = new Date()) => {
  const [r, m, d] = CENNIK.promocja.zalozoneDo.split('-').map(Number)
  return dzis <= new Date(r, m - 1, d, 23, 59, 59, 999)
}
